// @ts-nocheck
import React from 'react'
import PropTypes from 'prop-types'
import { colors } from '@lmc/common/constants'
import { isBrowser, isTablet } from 'react-device-detect'
import { Button, Icon } from '@lmc/ui-kit'

export default class Pagination extends React.Component {
  state = {
    changedPageSize: null
  }

  handleChangePageNumber = (number) => {
    const { count, onChangePageNumber, page } = this.props
    const totalPages = Math.ceil(count / page.size)
    if (number < 1 || number > totalPages) return null
    onChangePageNumber(number)
  }

  handleChangePageSize = (e) => {
    const { count, onChangePageSize, page } = this.props
    const changedPageSize = parseInt(e.target.value)
    const totalPages = Math.ceil(count / changedPageSize)

    if (page.number > totalPages) {
      this.handleChangePageNumber(totalPages)
    }
    this.setState({ changedPageSize })
    onChangePageSize(changedPageSize)
  }

  renderCount = () => {
    const { count, listId, page } = this.props

    let text
    const listText = listId || 'items'
    const size = page.size || this.state.changedPageSize

    if (count <= size) {
      text = `Showing all ${count} ${listText}`
    } else {
      const lowerBound = (page.number - 1) * size + 1
      const upperBound = page.number * size
      text = `Showing ${lowerBound} to ${upperBound} of ${
        count > 100 ? 'many' : count
      } ${listText}`
    }

    return <span style={styles.count}>{text}</span>
  }

  renderPages = () => {
    // Pages logic mostly taken from /elemental/Pagination
    const { count, displayOptions, page } = this.props

    if (!isDesktop) return null

    if (count <= page.size) {
      return <Page isSelected>1</Page>
    }
    const currentPage = page.number
    const totalPages = Math.ceil(count / page.size)
    const pages = []
    let minPage = 1
    let maxPage = totalPages

    if (DISPLAYED_PAGES_LIMIT < totalPages) {
      const rightLimit = Math.floor(DISPLAYED_PAGES_LIMIT / 2)
      const leftLimit = rightLimit + (DISPLAYED_PAGES_LIMIT % 2) - 1
      minPage = currentPage - leftLimit
      maxPage = currentPage + rightLimit

      if (minPage < 1) {
        maxPage = DISPLAYED_PAGES_LIMIT
        minPage = 1
      }
      if (maxPage > totalPages) {
        minPage = totalPages - DISPLAYED_PAGES_LIMIT + 1
        maxPage = totalPages
      }
    }
    pages.push(
      <Page
        key="first_page"
        isSelected={currentPage === 1}
        onClick={() => this.handleChangePageNumber(1)}
      >
        1
      </Page>
    )
    if (minPage > 2) {
      pages.push(
        <span key="first_ellipsis" style={styles.ellipsis}>
          ...
        </span>
      )
    }
    for (let page = minPage; page <= maxPage; page++) {
      if (page === 1 || page === totalPages) continue
      const isSelected = page === currentPage
      pages.push(
        <Page
          key={`page_${page}`}
          isSelected={isSelected}
          onClick={() => this.handleChangePageNumber(page)}
        >
          {page}
        </Page>
      )
    }
    if (maxPage < totalPages - 1) {
      pages.push(
        <span key="last_ellipsis" style={styles.ellipsis}>
          ...
        </span>
      )
    }
    if (displayOptions.lastPage) {
      pages.push(
        <Page
          key="last_page"
          isSelected={currentPage === totalPages}
          onClick={() => this.handleChangePageNumber(totalPages)}
        >
          {totalPages}
        </Page>
      )
    }
    return <div style={styles.pagesContainer}>{pages}</div>
  }

  renderSizeSelect = () => (
    <div style={styles.flexContainer}>
      <span>Show:</span>
      <select
        className="lmc-handover-select"
        onChange={this.handleChangePageSize}
        style={styles.select}
        value={this.props.page.size || this.state.changedPageSize}
      >
        <option value={10}>10 per page</option>
        <option value={20}>20 per page</option>
        <option value={50}>50 per page</option>
        <option value={100}>100 per page</option>
      </select>
    </div>
  )

  render() {
    const { displayOptions, page } = this.props
    if (!page) return null

    return (
      <div style={styles.wrapper}>
        {displayOptions.pageNumbers && (
          <div style={styles.flexContainer}>
            <Button
              icon={<Icon name="LeftOutlined" />}
              variant="default"
              onClick={() => this.handleChangePageNumber(page.number - 1)}
              style={{
                ...styles.edgeButton,
                marginRight: 4
              }}
            >
              Prev
            </Button>
            {this.renderPages()}
            <Button
              variant="default"
              icon={<Icon name="RightOutlined" />}
              iconPositionRight
              onClick={() => this.handleChangePageNumber(page.number + 1)}
              style={{
                ...styles.edgeButton,
                marginLeft: 4
              }}
            >
              Next
            </Button>
          </div>
        )}
        {this.renderSizeSelect()}
        {displayOptions.count && this.renderCount()}
      </div>
    )
  }
}

const Page = ({ children, onClick, isSelected }) => (
  <Button onClick={onClick} variant="default" style={styles.childButton}>
    {children}
  </Button>
)

const isDesktop = isBrowser || isTablet
const DISPLAYED_PAGES_LIMIT = 4

const styles = {
  count: {
    alignSelf: 'flex-end',
    color: colors.darkgrey,
    display: 'block',
    // fontSize: 12,
    marginRight: 12,
    paddingBottom: 1
  },
  edgeButton: {
    fontWeight: 400,
    textShadow: 'none'
  },
  ellipsis: {
    display: 'block',
    padding: 8
  },
  flexContainer: {
    alignItems: 'center',
    display: 'flex',
    marginRight: 24
  },
  pagesContainer: {
    display: 'flex'
  },
  select: {
    border: 'none',
    background: 'inherit',
    cursor: 'pointer',
    fontWeight: 600,
    paddingLeft: 10,
    textAlign: 'right',
    width: 120
  },
  wrapper: {
    display: 'flex',
    flexWrap: 'wrap'
  },
  childButton: {
    marginLeft: 2,
    marginRight: 2
  }
}

Pagination.defaulProps = {
  displayOptions: {
    count: true,
    lastPage: true,
    pageNumbers: true,
    pageSize: true
  }
}

Pagination.propTypes = {
  count: PropTypes.number,
  displayOptions: PropTypes.shape({
    count: PropTypes.bool,
    lastPage: PropTypes.bool,
    pageNumbers: PropTypes.bool,
    pageSize: PropTypes.bool
  }),
  page: PropTypes.shape({
    size: PropTypes.number.isRequired,
    number: PropTypes.number.isRequired
  }).isRequired,
  onChangePageNumber: PropTypes.func.isRequired,
  onChangePageSize: PropTypes.func.isRequired
}
